import { MessagePathNode, PathParser } from "../topics";

import { isStructuredRequirement, Requirement } from "./LayoutRecord";

/**
 * Renders a requirement as one dotted path, joining the topic name and message
 * path when the requirement stores them separately.
 *
 * Callers put the result in text users read, such as the warning that names the
 * data a panel could not find in the workspace. Display only: different
 * topic-name/message-path pairs can join to the same string, so the two parts
 * cannot be recovered from it.
 */
export function describeRequirement(requirement: Requirement): string {
  if (!isStructuredRequirement(requirement)) {
    return requirement.topicMessagePath;
  }

  if (requirement.messagePath.length === 0) {
    return requirement.topicName;
  }

  const messagePath = MessagePathNode.partsToString(requirement.messagePath);
  return `${requirement.topicName}${PathParser.TOPIC_SEPARATOR}${messagePath}`;
}
